import { render } from "./Family.vue?vue&type=template&id=271c4975&ts=true"
import script from "./Family.vue?vue&type=script&lang=ts"
export * from "./Family.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__